export enum AssetChargeReason {
  Lost = 1,
  Damaged = 2,
  Purchase = 3,
}

export enum AssetChargeStatus {
  Active = 1,
  Waived = 2,
  Settled = 3,
}

export interface AssetChargeInput {
  amount: number;
  installments: number;
  startPayrollPeriodKey?: string | null;
  note?: string | null;
}

export interface AssetChargeInstallment {
  number: number;
  dueDate: string;
  amount: number;
  deducted: boolean;
}

export interface AssetCharge {
  id: string;
  userId: string;
  userFullName?: string | null;
  assetId?: string | null;
  assetCode?: string | null;
  assetTitleAr?: string | null;
  assetTitleEn?: string | null;
  assetAssignmentId?: string | null;
  reason: AssetChargeReason;
  amount: number;
  installments: number;
  startPayrollPeriodKey: string;
  status: AssetChargeStatus;
  deducted: number;
  remaining: number;
  waivedAmount?: number | null;
  waiveReason?: string | null;
  waivedAt?: string | null;
  itemDescription?: string | null;
  note?: string | null;
  userLoanId: string;
  createdAtUtc: string;
  schedule: AssetChargeInstallment[];
}

export interface AssetChargePreview {
  monthlyInstallment: number;
  monthlySalary: number | null;
  otherLoanInstallments: number;
  exceedsSalary: boolean;
}

export interface AssetChargeQuery {
  userId?: string;
  assetId?: string;
  reason?: AssetChargeReason;
  status?: AssetChargeStatus;
  pageNumber?: number;
  pageSize?: number;
}

export interface CreatePurchaseCharge {
  userId: string;
  itemDescription: string;
  assetId?: string | null;
  amount: number;
  installments: number;
  startPayrollPeriodKey?: string | null;
  note?: string | null;
}
